/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Analytics_Desc9Inputs */

const en_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know what users do from day one, not after the budget is gone.`)
};

const ar_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعرف ما يفعله المستخدمون من اليوم الأول، لا بعد نفاد الميزانية.`)
};

const bn_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রথম দিন থেকেই জানুন ব্যবহারকারীরা কী করে, বাজেট শেষ হলে নয়।`)
};

const de_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wissen Sie ab Tag eins, was Nutzer tun, nicht erst, wenn das Budget weg ist.`)
};

const es_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saber qué hacen los usuarios desde el primer día, no cuando se acaba el presupuesto.`)
};

const fr_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sachez ce que font les utilisateurs dès le premier jour, pas quand le budget est parti.`)
};

const pt_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba o que os utilizadores fazem desde o primeiro dia, não quando o orçamento acaba.`)
};

const zh_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从第一天就知道用户在做什么，而不是等预算烧完。`)
};

const tr_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcıların ne yaptığını ilk günden bil, bütçe bitince değil.`)
};

const ru_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Знайте, что делают пользователи, с первого дня, а не когда кончится бюджет.`)
};

const pl_svc_mvp_sprint_analytics_desc9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiedz, co robią użytkownicy, od pierwszego dnia, nie gdy skończy się budżet.`)
};

/**
* | output |
* | --- |
* | "Know what users do from day one, not after the budget is gone." |
*
* @param {Svc_Mvp_Sprint_Analytics_Desc9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_analytics_desc9 = /** @type {((inputs?: Svc_Mvp_Sprint_Analytics_Desc9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Analytics_Desc9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_analytics_desc9(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_analytics_desc9(inputs)
	if (locale === "de") return de_svc_mvp_sprint_analytics_desc9(inputs)
	if (locale === "es") return es_svc_mvp_sprint_analytics_desc9(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_analytics_desc9(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_analytics_desc9(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_analytics_desc9(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_analytics_desc9(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_analytics_desc9(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_analytics_desc9(inputs)
	return en_svc_mvp_sprint_analytics_desc9(inputs)
});
export { svc_mvp_sprint_analytics_desc9 as "svc_mvp-sprint_ANALYTICS_desc" }